import { useParams } from 'react-router-dom';

import { MetricMerchantViewsWrapper } from '@/components/modules/Metrics/MetricMerchantViews/MetricMerchantViewsWrapper';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

export const MetricMerchantViews = () => {
  const { merchantId } = useParams();

  if (!merchantId) return null;

  return <MetricMerchantViewsWrapper merchantId={merchantId} />;
};

export const MetricMerchantViewsModule = withPermissionsModule(MetricMerchantViews);
